import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileService {
  private mobileSubject = new BehaviorSubject<boolean>(false);
  public mobile$ = this.mobileSubject.asObservable();

  constructor() {
    this.isMobile();
    window.addEventListener('resize', () => this.isMobile());
  }

  private isMobile(): void {
    this.mobileSubject.next(window.innerWidth < 768);
  }
}
